// extracted by mini-css-extract-plugin
export default {"reuseComponentOuterBox":"ReuseComponent_reuseComponentOuterBox__j-gTb"};